﻿<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { LibraryInformationElementService } from '@/shared/services/metadataService.ts';
    import VueMarkdown from '@/shared/components/VueMarkdown.vue';

    const governanceInformation = ref<string | null>(null);
    const libraryInfoService = new LibraryInformationElementService();

    const props = defineProps<{
        libraryName: string;
    }>();

    onMounted(async () => {
        const libInfoElements = await libraryInfoService.get(props.libraryName);

        if (libInfoElements.Governance) {
            governanceInformation.value = libInfoElements.Governance;
        }
    });
</script>

<template>
    <b-notification
        v-if="governanceInformation"
        type="is-info"
        :closable="false"
        has-icon
        role="alert">
        <h2
            v-if="governanceInformation"
            class="title is-size-4">
            Governance information
        </h2>
        <vue-markdown
            class="markdown unset-anchor-style"
            :source="governanceInformation" />
        <!-- unset-anchor-style is due to how the default link colour overrides any link color provided in scoped styles-->
    </b-notification>
</template>
